import styled from 'styled-components';
import { surface, ink, border, button } from '../UI/tokens';

export const SLayout = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${surface};
  color: ${ink};
  font-family: var(--ui-font);
  font-size: 14px;
  line-height: 1.5;
  @media (max-width: 768px) { flex-direction: column; }
`;
export const SMain = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 100vh;
  background-image: linear-gradient(rgba(128,145,167,.045), rgba(128,145,167,.045));
  @media (max-width: 768px) { width: 100%; }
`;
export const SContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding: clamp(16px, 2.2vw, 32px);
  .btn { ${button} }
  .card { border-color: ${border}; border-radius: 12px; }
  .pagination { gap: 4px; flex-wrap: wrap; margin: 16px 0; }
  .page-link { border-radius: 6px; }
`;
